<template>
  <v-app>
    <v-app-bar app>
      <v-spacer></v-spacer>

      <!-- TITULO PAGINA -->
      <v-toolbar-title>
        {{ $t("app.tituloPagina") }}
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- TRADUÇÃO BANDEIRAS -->
      <a class="mx-1" @click="traduzir('pt')">
        <v-img :src="require('@/assets/brasil.png')" max-width="45" class="rounded-pill">
        </v-img>
      </a>
      <a class="mx-1" @click="traduzir('en')">
        <v-img :src="require('@/assets/inglaterra.png')" max-width="45" class="rounded-pill">
        </v-img>
      </a>
      <a class="ml-1 mr-5" @click="traduzir('es')">
        <v-img :src="require('@/assets/espanha.png')" max-width="45" class="rounded-pill">
        </v-img>
      </a>
    </v-app-bar>

    <v-main>
      <v-container fluid fill-height class="fundo d-flex flex-column align-center justify-center">
        <v-card class="elevation-12" min-width="340">
          <v-card-title class="d-flex justify-center py-1"><v-img max-width="150"
              :src="require('@/assets/logo-seara.png')" alt="Logo Seara">
            </v-img></v-card-title>
          <v-card-text>
            <h2 class="text-center mb-2">{{ $t("Login.identificar") }}</h2>
            <v-form ref="form" @submit.prevent="login" autocomplete="off">
              <!-- e-mail -->
              <v-text-field :label="$t('Login.placeHolderUsuario')" type="email" v-model="usuario" required outlined dense
                clearable :rules="obrigatorioRules" autocomplete="username" id="username" autofocus>
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>
              </v-text-field>
              <!-- senha -->
              <v-text-field :label="$t('Login.placeHolderSenha')" v-model="senha" required outlined dense clearable
                :append-icon="mostrarEsconderSenha ? 'mdi-eye' : 'mdi-eye-off'"
                :type="mostrarEsconderSenha ? 'text' : 'password'" :rules="obrigatorioRules"
                autocomplete="current-password" id="current-password"
                @click:append="mostrarEsconderSenha = !mostrarEsconderSenha">
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>
              </v-text-field>
              <!-- botão login -->
              <v-btn type="submit" color="primary" block large>
                <v-icon left>mdi-login</v-icon>
                {{ $t("Login.btnEntrar") }}</v-btn>
            </v-form>
            <v-divider class="ma-7" inset></v-divider>

            <!-- botão esquecia senha -->
            <v-btn class="mt-4" color="amber accent-1" value="log in" block large @click="esqueciSenha">
              <v-icon left>mdi-lock-question</v-icon>
              {{ $t("Login.btnEsqueciSenha") }}
            </v-btn>
            <!-- botão cadastrar-se -->
            <v-btn class="mt-4" color="amber lighten-4" value="log in" block large @click="cadastroUsuario">
              <v-icon left>mdi-account-plus</v-icon>
              {{ $t("Login.btnCadastro") }}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-container>

      <!-- ERROS NA TELA -->
      <alerta-dialogo ref="alerta" />
      <!-- Loader -->
      <loader-dialogo ref="loader" />

    </v-main>
  </v-app>
</template>

<script>
import AlertaComponente from "../components/AlertaComponente.vue";
import LoaderComponente from "../components/LoaderComponente.vue";

export default {
  name: "App",
  components: {
    "alerta-dialogo": AlertaComponente,
    "loader-dialogo": LoaderComponente,
  },
  data() {
    return {
      obrigatorioRules: [
        (v) => !!v || "Login.campoObrigatorio",
        // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      usuario: "",
      senha: "",
      mostrarEsconderSenha: false,
    };
  },
  methods: {
    async login() {
      // console.log(this);
      // VALIDAR PREENCHIMENTO CAMPOS FORMULARIO HTML
      if (!this.$refs.form.validate()) {
        return false;
      }
      let urlLocal = "/login";
      this.usuario = this.usuario.toLowerCase();
      let retorno;

      // DEFINIR AMBIENTE DE EXECUÇÃO
      if (this.$ambiente == "DEV") urlLocal = this.$urlDEV + urlLocal;

      try {
        // eslint-disable-next-line
        //debugger;
        // return;
        this.$refs.loader.abrir();

        retorno = await fetch(urlLocal, {
          // signal: AbortSignal.timeout(1000),
          method: "POST", // *GET, POST, PUT, DELETE, etc.
          headers: {
            //   Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ usuario: this.usuario, senha: this.senha }),
        }).catch((error) => {
          throw new Error(`Fetch-${error}`);
        });

        // console.log(retorno);
        let json = await retorno.json();

        let cd_mensagem;
        if (json.ds_retorno.indexOf(">") > -1)
          cd_mensagem = json.ds_retorno.split(">")[0].substr(1);
        else cd_mensagem = "N";

        //SUCESSO
        if (json.cd_retorno == "OK") {
          // guardar usuario logado
          sessionStorage.setItem("australopitecus", btoa(this.usuario));
        } else if (json.cd_retorno == "NOK") {
          if (cd_mensagem == "N") {
            // AVISO MENSAGEM
            let descricaoErro = "Login - AVISO: " + json.ds_retorno;
            let origemErro = "Origem: " + urlLocal;
            this.$refs.alerta.abrir(descricaoErro, origemErro, "warning");
          } else {
            // AVISO MENSAGEM
            let descricaoErro =
              "Login - AVISO: " + this.$i18n.t("traducoesSrp." + cd_mensagem);
            let origemErro = "Origem: " + urlLocal;
            this.$refs.alerta.abrir(descricaoErro, origemErro, "warning");
          }
        } else {
          let descricaoErro =
            "Login - AVISO: " + this.$i18n.t("traducoesSrp." + cd_mensagem);
          let origemErro =
            "Origem: " + urlLocal + " - Others mensagem: " + json.ds_retorno;
          this.$refs.alerta.abrir(descricaoErro, origemErro, "warning");
        }

        // listar idioma do usuario
        try {
          if (sessionStorage.getItem("australopitecus") != null) {
            // eslint-disable-next-line
            // debugger;
            retorno = await this.listar_idioma();
            if (retorno == undefined) retorno = "en";
            localStorage.setItem("idioma", retorno);

            // Desviar para pagina HOME
            // window.location.href = json.ds_rota;
            if (json.ds_rota == "login/alterar_senha")
              this.$router.replace(json.ds_rota);
            else this.$router.replace("/app/home");
          }
        } catch (error) {
          let descricaoErro = `login-${error.message}`;
          console.log(descricaoErro)
          this.$refs.alerta.abrir(descricaoErro, null, "error");
        }

        this.$refs.loader.fechar();
      } catch (error) {
        let descricaoErro = `login-others-${error.message}`;
        console.log(descricaoErro)
        this.$refs.alerta.abrir(descricaoErro, null, "error");
      } finally {
        this.$refs.loader.fechar();
      }
    },
    async esqueciSenha() {
      let urlLocal = "/login/expirar_senha";
      // eslint-disable-next-line
      // debugger;
      // VALIDAR PREENCHIMENTO CAMPOS FORMULARIO HTML
      if (this.usuario == "" || this.usuario == null) {
        this.$refs.alerta.abrir(
          this.$i18n.t("Login.informarUsuario"),
          null,
          "warning"
        );
        return false;
      }

      this.usuario = this.usuario.toLowerCase();

      // DEFINIR AMBIENTE DE EXECUÇÃO
      if (this.$ambiente == "DEV") urlLocal = this.$urlDEV + urlLocal;
      let retorno;
      try {
        retorno = await fetch(urlLocal, {
          method: "POST", // *GET, POST, PUT, DELETE, etc.
          headers: {
            //   Accept: "application/json",
            "Content-Type": "application/json",
          },
          // mode: 'no-cors', // no-cors, *cors, same-origin
          // cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          body: JSON.stringify({ usuario: this.usuario }),
        });

        let json = await retorno.json();

        let cd_mensagem;
        if (json.ds_retorno.indexOf(">") > -1)
          cd_mensagem = json.ds_retorno.split(">")[0].substr(1);
        else cd_mensagem = "N";

        //SUCESSO
        if (json.cd_retorno == "OK") {
          this.$refs.alerta.abrir(
            this.$i18n.t("traducoesSrp." + cd_mensagem),
            null,
            "success"
          );
        } else if (json.cd_retorno == "NOK") {
          if (cd_mensagem == "N") {
            this.$refs.alerta.abrir(json.ds_retorno, null, "warning");
          } else {
            this.$refs.alerta.abrir(
              this.$i18n.t("traducoesSrp." + cd_mensagem),
              "Esq1",
              "warning"
            );
          }
        } else {
          this.$refs.alerta.abrir(
            this.$i18n.t("traducoesSrp." + cd_mensagem),
            "Esq2",
            "warning"
          );
        }
      } catch (error) {
        let descricaoErro = `Esqueci Senha - ERRO: ${error}`;
        let origemErro = `${retorno.url} - ${retorno.status} (${retorno.statusText})`;
        this.$refs.alerta.abrir(descricaoErro, origemErro, "error");
      }
    },
    async cadastroUsuario() {
      this.$router.push("/app/cadastro_usuario");
    },
    async listar_idioma() {
      let urlLocal = "/listar/listar_idioma";
      let descricaoErro;
      let origemErro = "Origem: " + urlLocal;
      urlLocal += "?id_usuario=" + this.usuario;

      // DEFINIR AMBIENTE DE EXECUÇÃO
      if (this.$ambiente == "DEV") urlLocal = this.$urlDEV + urlLocal;
      let retorno = await fetch(urlLocal)
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          try {
            //Converter em objeto
            if (json.idioma[0].ds_mensagem.indexOf("NOK") == -1) {
              let idioma;
              switch (json.idioma[0].cd_idioma) {
                case 1:
                  idioma = "pt";
                  break;
                case 2:
                  idioma = "en";
                  break;
                case 3:
                  idioma = "es";
                  break;
                default:
                  descricaoErro = `Listar idioma - AVISO - Idioma não encontrado: ${json.idioma[0].cd_idioma}`;
                  this.$refs.alerta.abrir(descricaoErro, origemErro, "warning");
                  console.log(descricaoErro, origemErro);
                  break;
              }
              return idioma;
            } else {
              descricaoErro =
                "Listar idioma - AVISO: " + json.idioma[0].ds_mensagem;
              //this.$refs.alerta.abrir(descricaoErro, origemErro, "warning");
              console.log(descricaoErro, origemErro);
              throw new Error(descricaoErro);
            }
          } catch (error) {
            descricaoErro = "Listar idioma - AVISO1: " + error;
            //this.$refs.alerta.abrir(descricaoErro, origemErro, "error");
            console.log(descricaoErro, origemErro);
            throw new Error(descricaoErro);
          }
        })
        .catch((error) => {
          descricaoErro = `listar_idioma-${error}`;
          // this.$refs.alerta.abrir(descricaoErro, origemErro, "error");
          // console.log(descricaoErro, origemErro);
          throw new Error(descricaoErro);
        });

      return retorno;
    },
    async traduzir(idioma) {
      // Mudar local I18N e Vuetify
      if (idioma && this.$i18n.locale != idioma) {
        this.$i18n.locale = idioma;
        this.$vuetify.lang.current = idioma;
        localStorage.setItem("idioma", idioma);

        // Tradução página
        document.title = this.$i18n.t("app.tituloPagina");
        document.documentElement.lang = idioma;
      }
    },
  },
  computed: {},
  mounted() {
    // fazer logoff
    // sessionStorage.removeItem("australopitecus");

    //Atualizar idioma do usuário
    this.traduzir(localStorage.getItem("idioma"));
    /*
    if (idioma && this.$i18n.locale != idioma) {
      this.$i18n.locale = idioma;
      this.$vuetify.lang.current = idioma;
      document.documentElement.lang = idioma;
      document.title = this.$i18n.t("app.tituloPagina");
    }
    */
  },
};
</script>

<style scoped>
/* IMAGEM DE FUNDO */
.fundo {
  background-image: url("../assets/fundo_sem_logo_claro.jpg");
  background-size: cover;
  background-repeat: no-repeat;
}
</style>